// The form posts without this script, so everything here is progressive. On load it
// sets `disabled` on both buttons, as the CLJS island rendered them, and the anonymous
// golden cells record that.
import "htmx.org"

const REVEAL_SECONDS = 3

// The page renders the server-error copy into `.text-error`; a page rendered with an
// error carries it in `data-server-error` instead, so the GET markup stays the island's.
const errorElement = document.querySelector(".login-page .text-error")
const serverError = errorElement?.dataset.serverError ?? errorElement?.textContent.trim()

let hideTimeout

function field(name) {
  return document.querySelector(`.login-page [name="${name}"]`)
}

function syncButtons() {
  const email = document.getElementById("email")
  const password = field("password")
  if (!email || !password) {
    return
  }
  email.classList.toggle("valid", Boolean(email.value))
  email.classList.toggle("invalid", !email.value)
  field("login_submit").disabled = !password.value
  field("email_login_submit").disabled = !email.value
}

function showPassword(icon, revealed) {
  icon.previousElementSibling.type = revealed ? "text" : "password"
  icon.classList.toggle("glyphicon-eye-close", revealed)
  icon.classList.toggle("glyphicon-eye-open", !revealed)
}

document.addEventListener("click", (event) => {
  const icon = event.target.closest?.(".login-page .has-feedback > i")
  if (!icon) {
    return
  }
  const revealing = icon.previousElementSibling.type === "password"
  showPassword(icon, revealing)
  clearTimeout(hideTimeout)
  if (revealing) {
    hideTimeout = setTimeout(() => showPassword(icon, false), REVEAL_SECONDS * 1000)
  }
})

// A fragment never reaches the server, so the island appended it to `next` itself.
// The field is added at submit time rather than rendered, in the capture phase so
// htmx collects it.
document.addEventListener(
  "submit",
  (event) => {
    const form = event.target
    if (!form.closest?.(".login-page") || !form.querySelector('[name="login_submit"]')) {
      return
    }
    const fragment = form.querySelector('[name="next_fragment"]') ?? document.createElement("input")
    fragment.type = "hidden"
    fragment.name = "next_fragment"
    fragment.value = window.location.hash
    form.append(fragment)
  },
  true,
)

let focusedName

document.addEventListener("htmx:before:swap", () => {
  focusedName = document.activeElement?.closest(".login-page")
    ? document.activeElement.name
    : undefined
})

document.addEventListener("htmx:after:swap", () => {
  syncButtons()
  const focused = focusedName && field(focusedName)
  const autofocused = document.querySelector(".login-page [autofocus]")
  ;(focused && !focused.disabled ? focused : (autofocused ?? field("password")))?.focus()
})

document.addEventListener("input", syncButtons)

function showServerError() {
  const error = document.querySelector(".login-page .text-error")
  if (error && serverError) {
    error.textContent = serverError
    error.style.visibility = "visible"
  }
}

// htmx 4 fires `htmx:response:error` for a 4xx/5xx and `htmx:error` only when the request throws.
document.addEventListener("htmx:response:error", showServerError)
document.addEventListener("htmx:error", showServerError)

syncButtons()
document.getElementById("email")?.focus()
